module.exports = __webpack_public_path__ + "static/media/plan-mas-400-gigas.57a69443.svg";